export const enum FlagNames {
  // UI
  DisabledAdminSections = 'dtu-ui.disabled-admin-sections',
  EnableMaintenanceScreen = 'dtu-ui.enable-maintenance-screen',
  GlobalBannerConfig = 'dtu-ui.global-banner-config',
  EnableBlockEmployeeExamScheduling = 'dtu-ui.enable-block-employee-exam-scheduling',
  Gen3AccountUuid = 'dtu-ui.gen-3-account-uuid',
  Gen3ClusterUuid = 'dtu-ui.gen-3-cluster-uuid',
  TestSectionConfig = 'dtu-ui.test-section-config',
  EnableDoceboLaunch = 'dtu-ui.enable-docebo-launch',

  // API
  EnableDoceboCertificationIntegration = 'dtu-api.enable-docebo-certification-integration',
  EnableDoceboPartnerCertificationIntegration = 'dtu-api.enable-docebo-partner-certification-integration',
  EnableDoceboLaunchApi = 'dtu-api.enable-docebo-launch',
  // Global Rate Limiter
  EnableGlobalRateLimiter = 'dtu-api.enable-global-rate-limiter',
  GlobalRateLimiterWindowSize = 'dtu-api.global-rate-limiter-window-size',
  GlobalRateLimiterAdminRequestMax = 'dtu-api.global-rate-limiter-admin-request-maximum',
  GlobalRateLimiterPublicRequestMax = 'dtu-api.global-rate-limiter-public-request-maximum',
  // Activity Rate Limiter
  EnableActivityRateLimiter = 'dtu-api.enable-activity-rate-limiter',
  ActivityRateLimiterWindowSize = 'dtu-api.activity-rate-limiter-window-size',
  ActivityRateLimiterAdminRequestMax = 'dtu-api.activity-rate-limiter-admin-request-maximum',
  ActivityRateLimiterPublicRequestMax = 'dtu-api.activity-rate-limiter-public-request-maximum',
}
